import { render, staticRenderFns } from "./AboutSection.vue?vue&type=template&id=51d2674c&scoped=true&"
import script from "./AboutSection.vue?vue&type=script&lang=js&"
export * from "./AboutSection.vue?vue&type=script&lang=js&"
import style0 from "./AboutSection.vue?vue&type=style&index=0&id=51d2674c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d2674c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VContainer,VRow,VSheet})
